import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class LoadingService {

  private loadingIndicatorSubject: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public loadingIndicator$: Observable<number> = this.loadingIndicatorSubject.asObservable();
  private loadingIndicator: number = 0;

  public setLoadingIndicator(action: string): void {
    if (action === 'increase') {
      this.loadingIndicator++;
    } else {
      this.loadingIndicator--;
    }
    setTimeout(() => {
      this.loadingIndicatorSubject.next(this.loadingIndicator);
    });
  }

  public getLoadingIndicator(): number {
    return this.loadingIndicator;
  }
}
